export enum AnnualAdministrationTrackerName {
  Administrations = "Administrations"
}

export default AnnualAdministrationTrackerName;
